module.exports = __webpack_public_path__ + "static/media/note4.2d16870c.png";